import initSelectCustom from '@ui/SelectCustom/component'
import submitForm from './submit-form'

export default function (): void {
  document.querySelectorAll<HTMLDetailsElement>('.reviews__filter details.o-select-custom').forEach((el) => {
    initSelectCustom(el)
  })

  const form = document.getElementById('reviews_sort_sort')

  if (form) {
    form.addEventListener('change', function () {
      submitForm(document.querySelector('form[name=reviews_sort') as HTMLFormElement)
    })
  }
}
